/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_No_AccountInputs */

const en_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const es_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes una cuenta?`)
};

const fr_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas de compte ?`)
};

const de_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Konto?`)
};

const ja_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントをお持ちでないですか？`)
};

const zh_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账号？`)
};

const ar_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليس لديك حساب؟`)
};

const id_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum punya akun?`)
};

const it_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai un account?`)
};

const ru_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет аккаунта?`)
};

const pt_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tem uma conta?`)
};

const ko_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 없으신가요?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_No_AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_no_account = /** @type {((inputs?: Auth_No_AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_No_AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_no_account(inputs)
	if (locale === "es") return es_auth_no_account(inputs)
	if (locale === "fr") return fr_auth_no_account(inputs)
	if (locale === "de") return de_auth_no_account(inputs)
	if (locale === "ja") return ja_auth_no_account(inputs)
	if (locale === "zh") return zh_auth_no_account(inputs)
	if (locale === "ar") return ar_auth_no_account(inputs)
	if (locale === "id") return id_auth_no_account(inputs)
	if (locale === "it") return it_auth_no_account(inputs)
	if (locale === "ru") return ru_auth_no_account(inputs)
	if (locale === "pt") return pt_auth_no_account(inputs)
	return ko_auth_no_account(inputs)
});